/*
 * Do not remove or alter the notices in this preamble.
 * This software code regards iO Custom Software.
 * Copyright © 2026 iO The Netherlands B.V. and/or its affiliates.
 * www.iodigital.com All rights reserved. License grant and user rights and obligations
 * according to applicable license agreement. Please contact legal@iodigital.com for
 * questions regarding license and user rights.
 */

import { consume } from '@lit/context';
import { css, html, LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

import { global, GlobalComponentType } from '@/context';
import { BREAKPOINT_MEDIUM_PX } from '@/settings';
import { baseStyles } from '@/styles';

import './color-step-skeleton-loader';
import './pricebreakdown-skeleton-loader';
import './print-option-step-skeleton-loader';
import './quantity-step-skeleton-loader';
import './wholesale-configurator-skeleton-loader';

@customElement('fg-configurator-skeleton-loader')
export class FgConfiguratorSkeletonLoader extends LitElement {
  @consume({ context: global.context, subscribe: true })
  globalContext!: GlobalComponentType;

  render() {
    const layout = this.globalContext?.layout || 'retail';

    return html`
      <div class="configurator-skeleton-loader">
        ${layout === 'retail'
          ? html`
              <div class="retail-layout">
                <fg-color-step-skeleton-loader></fg-color-step-skeleton-loader>
                <fg-print-option-step-skeleton-loader></fg-print-option-step-skeleton-loader>
                <fg-quantity-step-skeleton-loader></fg-quantity-step-skeleton-loader>
                <fg-pricebreakdown-skeleton-loader></fg-pricebreakdown-skeleton-loader>
              </div>
            `
          : layout === 'wholesale'
            ? html`
                <fg-wholesale-configurator-skeleton-loader></fg-wholesale-configurator-skeleton-loader>
              `
            : nothing}
      </div>
    `;
  }

  static styles = [
    baseStyles,
    css`
      .configurator-skeleton-loader {
        width: 100%;
      }

      .retail-layout {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }

      @media (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
        .retail-layout {
          gap: 1.5rem;
        }
      }
    `,
  ];
}
